import React, { useEffect, useState } from 'react'
import ConfigurationHeader from '../../components/heading/ConfigurationHeader'
import Input, {DashboardCheckbox, InputList} from '../../components/Input/Input'
import { popupType } from '../../types/types'
import { convertValuesToConfig, createValidation, getMetaDataConfig, getNewConfiguration, postConfiguration, updateConfiguration } from '../../services/uiConfigService'
import * as yup from 'yup'
import { GenericPopUp } from '../../components/popup/genericPopUp'
import * as Sentry from "@sentry/react";
import { IndentWrapper } from '../orderConfiguration/OrderConfiguration'
import QuestionHeading from '../../components/heading/QuestionHeading'
import { validateWithOtp } from '../../stateManagement/actions/validateOtpPopupActions'
import { manageUpdateAccessObj } from '../manageUpdateAccess/manageUpdateAccessTypes'
import { deepClone } from '@mui/x-data-grid/utils/utils'
import './HelpdeskOption.css'
import { configurationAttributeType, helpdeskConfigurationValuesTypes } from '../../types'
import { helpdeskDefaultValues } from '../defaultConfigurations/helpdeskConfigDefaultValue'


const HelpdeskConfiguration = (props:{showBackButton?:boolean}) => {
    const [helpdeskConfig, setHelpdeskConfig] = useState<configurationAttributeType[]>([]);
    const [values, setValues] = useState<helpdeskConfigurationValuesTypes>(deepClone(helpdeskDefaultValues))
    const [helpdeskValidationsSchema, setHelpdeskValidationSchema] = useState({})
    const [openGenericModal, setOpenGenericModal] = useState(false);
    const [popupType, setPopupType] = useState<popupType>("Alert");
    const [genericMessage, setGenericMessage] = useState("");


    const openPopup = (message: string, type: popupType) => {
        setPopupType(type)
        setGenericMessage(message)
        setOpenGenericModal(true)
    }
    useEffect(() => {
        const getHelpdeskConfiguration = async () => {
            try {
                const resp = await getNewConfiguration('helpdesk_options_configuration');
                const helpdesk_config: configurationAttributeType[] = resp?.domainValues;
                setHelpdeskConfig([...helpdesk_config])
            } catch (err) {
                Sentry.captureException(err);
            }
        }
        getHelpdeskConfiguration();
    }, [])


    const saveConfiguration = async (preview?: boolean) => {
        validateWithOtp(async (verifiedUser?: manageUpdateAccessObj)=>{
            try {
                const configName = (preview ? "helpdesk_options_configuration_preview" : "helpdesk_options_configuration") 
                const helpdeskSchema = yup.object({ ...helpdeskValidationsSchema })
                const validationObject:any = {};
                Object.keys(values).forEach(key=>{
                    validationObject[key] = values[key].value;
                })
                // await helpdeskSchema.validate(validationObject)
                const convertedVals = convertValuesToConfig(values, helpdeskConfig);
                let clientConfig = await getMetaDataConfig("clientconfig");
                if (clientConfig.find((config: { domainType: string }) => config.domainType === configName)) {
                    await updateConfiguration(configName, convertedVals, verifiedUser)
                } else
                    await postConfiguration(configName, convertedVals, verifiedUser)
                openPopup("Configuration Updated", 'Success')
    
            } catch (err) {
                Sentry.captureException(err);
                console.log("err===", err)
                if (err instanceof Error)
                    openPopup("Validation Error occured : " + err?.message, 'Error')
            }
        })
        
    }

   
    const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const keyName = e.target.name;
        setValues({
            ...values,
            [keyName]: {...values[keyName], value:e.target.value, isValueUpdated:true} 
        })
    }

    const handleCheckChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const keyName = e.target.name;
        setValues({
            ...values,
            [keyName]: {...values[keyName], value:e.target.checked, isValueUpdated:true} 
        })
    }

    const setHelpdeskConfigValues = () => {
        try {
            if (helpdeskConfig.length) {
                const result = { ...values } 
                const resValidations = {} as { [key: string]: ReturnType<typeof createValidation> }
                helpdeskConfig.forEach((attr) => {
                    resValidations[attr.name] = createValidation(attr)
                    result[attr.name] = attr
                })
                setValues({ ...result as helpdeskConfigurationValuesTypes });
                setHelpdeskValidationSchema({ ...resValidations })
            }
        } catch (err) {
            Sentry.captureException(err);
        }
    }

    useEffect(() => {
        setHelpdeskConfigValues();
    }, [helpdeskConfig])


    return (
        <div className="helpdesk_config_container">
            <ConfigurationHeader heading={"Helpdesk Configuration"} showBackButton={props.showBackButton} saveConfiguration={() => saveConfiguration(false)} createPreview={() => saveConfiguration(true)} />
            <div className="config_form_container">

            <IndentWrapper indent={1}>
                    <InputList values={values} question="priorityTypes" setValues={setValues} configName="priorityTypes" />
            </IndentWrapper>

            <IndentWrapper indent={1}>
                    <InputList values={values} question="complaintTypes" setValues={setValues} configName="complaintTypes" />
            </IndentWrapper>
           
            
            </div>
            <GenericPopUp message={genericMessage}
                type={popupType}
                openGenericModal={openGenericModal}
                setOpenGenericModal={setOpenGenericModal} />
        </div>
    )
}

export default HelpdeskConfiguration